import { Stack, Tooltip, Typography } from '@mui/material';
import { Image } from '@retail/components';
import React from 'react';
import { PriceRoundingRuleConfig } from '@retail/rounding/types';
import { useRoundingTFunction } from '@retail/rounding/i18n';

interface Props {
  ruleSetConfig: PriceRoundingRuleConfig;
}

export const PriceRoundingRuleMemberHeader: React.FC<Props> = ({ ruleSetConfig }) => {
  const t = useRoundingTFunction();

  return (
    <Stack direction="row" alignItems="center" gap={2}>
      <Typography variant="h5" component="h2">
        {ruleSetConfig.name}
      </Typography>
      {ruleSetConfig.centralOwner && (
        <Tooltip
          title={t('rounding.ruleOwner.central', {
            owner: ruleSetConfig.centralOwner.name,
          })}
        >
          <Image
            src={ruleSetConfig.centralOwner.imgUrl}
            alt={ruleSetConfig.centralOwner.name}
            width={32}
            height={32}
          />
        </Tooltip>
      )}
    </Stack>
  );
};
